export class OMKError extends Error {
  public static errorName = 'OMKError';

  public constructor(message) {
    super(message);
    this.name = OMKError.errorName;
  }
}

export class OMKRequestError extends Error {
  public static errorName = 'OMKRequestError';

  public constructor(message) {
    super(message);
    this.name = OMKRequestError.errorName;
  }
}
